import { useNavigate } from 'react-router-dom';
import packageJson from '../../../package.json';
import { useDispatch } from 'react-redux';
import { resetErrors, setOverlay } from '../../redux/slices/appStateSlice';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';

const appendTrailingSlash = url => {
  return url.endsWith('/') ? url : `${url}/`;
};

const removeBodyLock = () => {
  if (!isEditorActive()) {
    document.body.classList.remove('vds-body-locked');
  }
};

export function useInternalNavigate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let urlPrefix = '';
  if (process.env.NODE_ENV === 'production') {
    urlPrefix = packageJson.config.virtualFolder;
  }
  return (url, options) => {
    const internalUrl = urlPrefix + url;
    dispatch(resetErrors());
    dispatch(setOverlay(null));
    removeBodyLock();
    navigate(appendTrailingSlash(internalUrl), options);
  };
}
